import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const DEFAULT_VISION_TRAY_NAME_CHARS = 300;

const resolveVisionTrayNameMax = (configuration) => {
  const parsed = Number(configuration?.visionTrayNameMaxChars);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_VISION_TRAY_NAME_CHARS;
};

const TrayVisionName = ({ text, onOpen }) => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const maxChars = resolveVisionTrayNameMax(configuration);
  const value = String(text || "");
  if (value.length <= maxChars) {
    return value || "—";
  }
  return (
    <>
      {value.slice(0, maxChars)}
      {"… "}
      <button
        type="button"
        className="btn btn-link btn-sm p-0 align-baseline"
        onClick={onOpen}
      >
        {t("buttons.seeMore", "Ver más")}
      </button>
    </>
  );
};

TrayVisionName.propTypes = {
  text: PropTypes.string,
  onOpen: PropTypes.func.isRequired
};

export default TrayVisionName;
